import { RouterProvider} from "react-router-dom";
import { router } from "./router";
import { GlobalSpinner } from "./components/GlobalSpinner";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function App() {
  localStorage.clear();
  return (
    <RouterProvider
      router={router}
      fallbackElement={<GlobalSpinner/>}
    />
  );
}

export default App;
